import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateDocumentTypeFailure,
  CreateDocumentTypeRequest,
  CreateDocumentTypeSuccess,
  DeleteDocumentTypeFailure,
  DeleteDocumentTypeRequest,
  DeleteDocumentTypeSuccess,
  FetchDocumentTypeFailure,
  FetchDocumentTypeRequest,
  FetchDocumentTypeSuccess,
  FetchDocumentTypesFailure,
  FetchDocumentTypesRequest,
  FetchDocumentTypesSuccess,
  UpdateDocumentTypeFailure,
  UpdateDocumentTypeRequest,
  UpdateDocumentTypeSuccess,
} from './document-types.actions'
import { DocumentTypesService } from './document-types.service'
import * as DocumentTypes from './document-types.types'

@Injectable()
export class DocumentTypesEffects {
  constructor(
    private actions: Actions,
    private documentTypesService: DocumentTypesService,
    private router: Router,
  ) {}

  FetchDocumentTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(DocumentTypes.FETCH_DOCUMENT_TYPES_REQUEST),
      switchMap((action: FetchDocumentTypesRequest) => {
        return this.documentTypesService
          .fetchDocumentTypes(action.payload)
          .pipe(
            map((result) => {
              return new FetchDocumentTypesSuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchDocumentTypesFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchDocumentType$ = createEffect(() =>
    this.actions.pipe(
      ofType(DocumentTypes.FETCH_DOCUMENT_TYPE_REQUEST),
      switchMap((action: FetchDocumentTypeRequest) => {
        return this.documentTypesService.fetchDocumentType(action.id).pipe(
          map((result) => {
            return new FetchDocumentTypeSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchDocumentTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteDocumentType$ = createEffect(() =>
    this.actions.pipe(
      ofType(DocumentTypes.DELETE_DOCUMENT_TYPE_REQUEST),
      switchMap((action: DeleteDocumentTypeRequest) => {
        return this.documentTypesService.deleteDocumentType(action.id).pipe(
          switchMap(() => {
            return [new DeleteDocumentTypeSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteDocumentTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateDocumentType$ = createEffect(() =>
    this.actions.pipe(
      ofType(DocumentTypes.CREATE_DOCUMENT_TYPE_REQUEST),
      switchMap((action: CreateDocumentTypeRequest) => {
        return this.documentTypesService
          .createDocumentType(action.payload)
          .pipe(
            switchMap(() => {
              this.router.navigate(['/admin/document-types'])
              return [new CreateDocumentTypeSuccess()]
            }),
            catchError(() => {
              return of(new CreateDocumentTypeFailure({}))
            }),
          )
      }),
    ),
  )

  UpdateDocumentType$ = createEffect(() =>
    this.actions.pipe(
      ofType(DocumentTypes.UPDATE_DOCUMENT_TYPE_REQUEST),
      switchMap((action: UpdateDocumentTypeRequest) => {
        return this.documentTypesService
          .updateDocumentType(action.id, action.payload)
          .pipe(
            switchMap(() => {
              this.router.navigate(['/admin/document-types'])
              return [new UpdateDocumentTypeSuccess()]
            }),
            catchError(() => {
              return of(new UpdateDocumentTypeFailure({}))
            }),
          )
      }),
    ),
  )
}
